import { createFileRoute } from "@tanstack/react-router"
import { ApiTokensSection } from "./_api-tokens"

export const Route = createFileRoute("/settings/tokens")({
  component: ApiTokensSection,
})
